import React from 'react'
import AboutInfo from '../components/AboutInfo'

export default function About() {
  return <AboutInfo />
}
